import CheckIcon from "assets/svgIcons/NormalTickIcon";
import {
  SettingContainer,
  SettingsWrapper,
  HoleWrapper,
  PaceTimer,
  HoleBox,
} from "pages/Pace/Settings/SettingsPageStyled";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import { API_STATUSES } from "redux/_helpers/statuses";
import { Loader } from "commonComponents/Loader/Loader";
import {
  ADS_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  CHECKBOX_LOADER,
  FLEET_GLOBAL_STATES,
} from "../../../globalStore/globalStore";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly, getFeatureSetOption, getFeaturesList } from "constant";
import { Tooltip } from "@mui/material";
import { CircleBtn, PopUpContainer } from "assets/css/globle";
import {
  CheckBoxWrapper,
} from "pages/Fleet/Settings/SettingsStyled";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { featureKey } from "constant";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "444px",
  width: "calc(100% -  40px)",
  bgcolor: "background.paper",
  borderRadius: "5px",
  overflow: "hidden",
};

const Settings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { alertMsg, redirectState, nextTabIndex, nextStageName } = useHookstate(ADS_GLOBAL_STATE);
  const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { callSiteSelection } = useHookstate(MAP_GLOBAL_STATES);
  const { siteId, hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);

  const {
    siteSettingsData,
    getRoundTimeOutData,
    getRoundTimeOutStatus,
    putRoundTimeOutStatus,
    getUserRole,
  } = useSelector((state) => state.commonReducers) || [];

  const dispatch = useDispatch();

  const [timeAtTurn, setTimeAtTurn] = useState(null);
  const [paceEnabled, setPaceEnabled] = useState(true);
  const [warningThreshold, setWarningThreshold] = useState(5);
  const [criticalThreshold, setCriticalThreshold] = useState(5);
  const [courseList, setcourseList] = useState([]);
  const [putloaderState, setPutloaderState] = useState(false);
  const [resetCourseList, setResetCourseList] = useState([]);
  const [resetPaceEnabled, setResetPaceEnabled] = useState(true);
  const [resetwarningThreshold, setResetwarningThreshold] = useState(5);
  const [resetcriticalThreshold, setResetcriticalThreshold] = useState(5);
  const [resetTimeAtTurn, setResetTimeAtTurn] = useState(null);
  const [confirmMsg, setConfirmMsg] = useState(false);

  const {
    behindPaceWarningGlobal,
    paceStatusTimeGlobal,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const { roundManagementLoader } = useHookstate(CHECKBOX_LOADER);

  let newPs = {};
  let updatedSettings = {};

   useEffect(() => {
      if(Object.keys(siteSettingsData).length > 0) {
        if(!siteSettingsData?.Features?.includes(featureKey.golf)) {
          navigate("/dashboard", { replace: true });
        }
      }
    }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    dispatch(COMMON_SERVICES.getRoundTimeOutServices(siteId.get()));

    setcourseList([]);
  }, [siteId.get()]);

  useEffect(() => {
    if (siteSettingsData) {
      setWarningThreshold(siteSettingsData?.WarningThreshold);
      setCriticalThreshold(siteSettingsData?.CriticalThreshold);
      setPaceEnabled(siteSettingsData?.PaceEnabled);
      setResetwarningThreshold(siteSettingsData?.WarningThreshold);
      setResetcriticalThreshold(siteSettingsData?.CriticalThreshold);
      setResetPaceEnabled(siteSettingsData?.PaceEnabled);
      behindPaceWarningGlobal.set(siteSettingsData.PaceWarningPopupEnabled);
      paceStatusTimeGlobal.set(siteSettingsData.PaceStatusTimeAutoPopup);
    }
  }, [siteSettingsData]);

  useEffect(() => {
    if (getRoundTimeOutData) {
      var secondsAtTurn = getRoundTimeOutData?.site?.SecondsAtTurn / 60;

      setTimeAtTurn(Number.isNaN(secondsAtTurn) ? 0 : secondsAtTurn);
      setResetTimeAtTurn(Number.isNaN(secondsAtTurn) ? 0 : secondsAtTurn);
    }
  }, [getRoundTimeOutData]);

  useEffect(() => {
    populateSettings();
  }, [getRoundTimeOutData]);

  function frontTotal(course) {
    let total = 0;
    for (let i = 0; i < course?.frontHoles.length; i++) {
      const paceValue = parseInt(course?.frontHoles[i]?.pace);
      total += Number.isNaN(paceValue) ? 0 : paceValue;
    }

    return moment().startOf("day").minutes(total).format("H:mm");
  }

  function backTotal(course) {
    let total = 0;
    for (let i = 0; i < course?.backHoles.length; i++) {
      const paceValue = parseInt(course?.backHoles[i]?.pace);
      total += Number.isNaN(paceValue) ? 0 : paceValue;
    }
    return moment().startOf("day").minutes(total).format("H:mm");
  }

  function courseTotal(course) {
    let frontTotalVal = frontTotal(course);
    frontTotalVal = moment(frontTotalVal, "HH:mm").diff(
      moment().startOf("day"),
      "minutes"
    );
    let backTotalVal = backTotal(course);
    backTotalVal = moment(backTotalVal, "HH:mm").diff(
      moment().startOf("day"),
      "minutes"
    );
    let total = frontTotalVal + backTotalVal + (parseInt(timeAtTurn) || 0);
    return moment().startOf("day").minutes(total).format("H:mm");
  }

  function CourseModel(course) {
    let name = course?.$Name;
    let number = parseInt(course?.$CourseNumber);
    let firstHole = parseInt(course?.$FirstHole);
    let holeCount = parseInt(course?.$HoleCount);
    let frontHoles = [];
    let backHoles = [];

    let frontTotal = function () {
      let total = 0;
      for (let i = 0; i < frontHoles.length; i++) {
        const paceValue = parseInt(frontHoles[i].pace);
        total += Number.isNaN(paceValue) ? 0 : paceValue;
      }
      return total;
    };

    let backTotal = function () {
      let total = 0;
      for (let i = 0; i < backHoles.length; i++) {
        const paceValue = parseInt(backHoles[i].pace);
        total += Number.isNaN(paceValue) ? 0 : paceValue;
      }
      return total;
    };

    for (let i = 0; i < course?.Holes?.Hole.length; i++) {
      let hole = course?.Holes?.Hole[i];
      let obsHole = {
        number: parseInt(hole?.$Number),
        pace: hole?.PaceInSeconds / 60,
      };
      if (i < 9) frontHoles.push(obsHole);
      else backHoles.push(obsHole);
    }

    return {
      name: name,
      number: number,
      firstHole: firstHole,
      holeCount: holeCount,
      frontHoles: frontHoles,
      backHoles: backHoles,
      frontTotal: frontTotal,
      backTotal: backTotal,
    };
  }

  function populateSettings() {
    let ps = JSON.parse(JSON.stringify(getRoundTimeOutData && getRoundTimeOutData));

    if (ps) {
      if (Array.isArray(ps?.site?.Courses?.Course) && ps?.site?.Courses?.Course && ps?.site?.Courses?.Course.length !== 0) {
        for (let c = 0; c < ps?.site?.Courses?.Course.length; c++) {
          courseList.push(new CourseModel(ps?.site?.Courses?.Course[c]));
        }
      } else {
        if (ps?.site?.Courses?.Course === undefined) {
          return;
        }
        courseList.push(new CourseModel(ps?.site?.Courses?.Course));
      }
    }

    getCourseData();
  }

  function getCourseData() {
    const result = courseList.filter(
      (thing, index, self) =>
        index === self.findIndex((t) => t?.name === thing.name)
    );
    setResetCourseList(result);
    setcourseList(result);
  }

  function dePopulateCourse(srcCourse, destCourse) {
    for (let i = 0; i < srcCourse?.frontHoles.length; i++) {
      let srcHole = srcCourse?.frontHoles[i];

      let destHole = destCourse?.Holes?.Hole?.find((h) => {
        return parseInt(h.$Number) === srcHole.number;
      });

      destHole.PaceInSeconds = (srcHole.pace * 60).toFixed();
    }
    for (let i = 0; i < srcCourse?.backHoles.length; i++) {
      let srcHole = srcCourse?.backHoles[i];
      let destHole = destCourse?.Holes?.Hole?.find((h) => {
        return parseInt(h.$Number) === srcHole.number;
      });

      destHole.PaceInSeconds = (srcHole.pace * 60).toFixed();
    }
  }

  function saveChanges() {
    roundManagementLoader.set(true);
    dispatch(
      COMMON_SERVICES.putBehindPaceWarningServices(
        false,
        siteId.get()
      )
    ).then(() => {
      behindPaceWarningGlobal.set(false);
      roundManagementLoader.set(false);
    });
    roundManagementLoader.set(true);
    dispatch(
      COMMON_SERVICES.putPaceStatusTimeServices(
        false,
        siteId.get()
      )
    ).then(() => {
      paceStatusTimeGlobal.set(false);
      roundManagementLoader.set(false);
    });
  }

  function dePopulateSettings() {
    let ps = JSON.parse(
      JSON.stringify(getRoundTimeOutData && getRoundTimeOutData)
    );
    let ss = JSON.parse(JSON.stringify(siteSettingsData && siteSettingsData));

    let newSs = {
      ...ss,
      WarningThreshold: Number(warningThreshold),
      CriticalThreshold: Number(criticalThreshold),
      PaceEnabled: paceEnabled,
    };

    if (ps && Object.keys(ps).length !== 0) {
      if (courseList.length > 1) {
        for (let c = 0; c < courseList.length; c++) {
          let srcCourse = courseList[c];
          let destCourse = ps?.site?.Courses?.Course[c];
          dePopulateCourse(srcCourse, destCourse);
        }
      } else {
        let srcCourse = courseList[0];
        let destCourse = ps?.site?.Courses?.Course;
        dePopulateCourse(srcCourse, destCourse);
      }
    }

    let chkPs = {
      ...ps,
      site: { ...ps.site, SecondsAtTurn: (timeAtTurn * 60).toFixed() },
    };

    newPs = chkPs;
    updatedSettings = newSs;
  }

  function handleFrontCourseList(e, courseIndex, holeIndex) {
    const tempCourseList = JSON.parse(JSON.stringify(courseList));

    tempCourseList[courseIndex].frontHoles[holeIndex].pace = Number(
      e.target.value
    );
    setcourseList(tempCourseList);
    redirectState.set(true);
  }

  function handleBackHolesCourseList(e, courseIndex, holeIndex) {
    const tempCourseList = JSON.parse(JSON.stringify(courseList));

    tempCourseList[courseIndex].backHoles[holeIndex].pace = Number(
      e.target.value
    );
    setcourseList(tempCourseList);
    redirectState.set(true);
  }

  if (getRoundTimeOutStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  if (putRoundTimeOutStatus === API_STATUSES.SUCCESS) {
    setTimeout(() => {
      return <Loader />;
    }, 1000);
  }

  function handleSaveChanges() {
    dePopulateSettings();
    if (!paceEnabled) {
      saveChanges();
    }

    let payload = {
      paceSettings: newPs,
      siteId: Number(siteId.get()),
      siteSettings: updatedSettings,
    };

    setPutloaderState(true);
    dispatch(
      COMMON_SERVICES.putRoundTimeOutServices(payload, Number(siteId.get()))
    ).then(() => {
      dispatch(COMMON_SERVICES.getRoundTimeOutServices(siteId.get()));
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      setPutloaderState(false);
      redirectState.set(false);
    });
  }

  function handleResetChanges() {
    redirectState.set(false);
    alertMsg.set(false);
    if (confirmMsg) {
      setcourseList(resetCourseList);

      setWarningThreshold(resetwarningThreshold);
      setCriticalThreshold(resetcriticalThreshold);

      setPaceEnabled(resetPaceEnabled);
      setTimeAtTurn(resetTimeAtTurn);
      setConfirmMsg(false);
      if (!resetPaceEnabled) {
        saveChanges();
      }
    } else {
      hideSubNav.set(true);
      if (nextStageName.get() === "siteSelection") {
        callSiteSelection.set(true);
        return;
      }
      navigate(`/${nextStageName.get().toLowerCase()}`);
      let activeTab = nextTabIndex.get();
      let activeName = nextStageName.get();
      sideDrawerActiveTabState.set(activeTab);
      subNavDataState.set(activeName);

      localStorage.setItem("sideDrawerActiveTabState", nextTabIndex.get());

      localStorage.setItem("subNavState", "true");
      localStorage.setItem("subNavDataState", nextStageName.get());
    }
  }

  const getCourseName = (courseNumber) => {
    const course = siteSettingsData?.Courses.filter(x => x.Number == courseNumber)[0];
    return course?.Name;
  }

  return (
    <>
      {putloaderState ? (
        <Loader />
      ) : (
        <>
          <SettingContainer>
            <SettingsWrapper>
              {roundManagementLoader.get() && (
                <CenteredLoader className="innerSectionLoader">
                  <Loader />
                </CenteredLoader>
              )}
              <div style={{ borderBottom: "1px solid #d1d0cb", paddingBottom: "15px" }} >
                <h3>{t("Settings")}</h3>
              </div>
              <div className="header">
                <Tooltip title={t("Pace_of_play_enabled")}>
                  <button
                    disabled={
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    className={paceEnabled ? "active" : ""}
                    onClick={() => {
                      setPaceEnabled(!paceEnabled);
                      redirectState.set(true);
                    }}
                  >
                    {paceEnabled ? <CheckIcon /> : <></>}{t("Pace_of_play_enabled")}
                  </button>
                </Tooltip>
              </div>
              <div style={{ width: "25%" }}>
                <CheckBoxWrapper className="mb-10">
                  <CustomizedCheckbox
                    lockdownText="behindPaceWarning"
                    label={t("Behind_Pace_Warning")}
                    name="Behind Pace Warning"
                    width={15}
                    height={15}
                    paceEnabled={paceEnabled}
                    disabled={!paceEnabled ||
                      getFeatureSetOption(
                        siteSettingsData && siteSettingsData?.Features,
                        getFeaturesList().golfer_experience
                      ) ||
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper className="mb-10">
                  <CustomizedCheckbox
                    lockdownText="paceStatusTime"
                    label={t("Pace_Status_Time")}
                    name="Pace Status Time"
                    width={15}
                    height={15}
                    paceEnabled={paceEnabled}
                    disabled={!paceEnabled ||
                      getFeatureSetOption(
                        siteSettingsData && siteSettingsData?.Features,
                        getFeaturesList().golfer_experience
                      ) ||
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                  />
                </CheckBoxWrapper>
              </div>
              <PaceTimer>

                <div className="behind-pace">
                  <p>
                    {t("Behind")} {t("Pace")}
                  </p>
                  <input
                    type="number"
                    min={1}
                    max={99}
                    value={warningThreshold}
                    onChange={(e) => {
                      setWarningThreshold(e.target.value);
                      redirectState.set(true);
                    }}
                  />
                </div>
                <div className="critically-behind">
                  <p>{t("Critically_behind")}</p>
                  <input
                    type="number"
                    min={1}
                    max={99}
                    value={criticalThreshold}
                    onChange={(e) => {
                      setCriticalThreshold(e.target.value);
                      redirectState.set(true);
                    }}
                  />
                </div>
                <div className="time-at-turn">
                  <p>{t("Time_at_turn")}</p>
                  <input
                    type="number"
                    min={0}
                    max={99}
                    value={timeAtTurn}
                    onChange={(e) => {
                      setTimeAtTurn(e.target.value);
                      redirectState.set(true);
                    }}
                  />
                </div>

                {redirectState.get() ? (
                  <>
                    <div className="action-wrapper">
                      <CircleBtn
                        disabled={
                          isUserBasic(getUserRole && getUserRole?.Role) ||
                          isUserReadOnly(getUserRole && getUserRole?.Role)
                        }
                        onClick={handleSaveChanges}
                        className="active"
                      >
                        {t("Save")}
                      </CircleBtn>
                      <CircleBtn
                        disabled={
                          isUserBasic(getUserRole && getUserRole?.Role) ||
                          isUserReadOnly(getUserRole && getUserRole?.Role)
                        }
                        onClick={() => {
                          alertMsg.set(true);
                          setConfirmMsg(true);
                        }}
                      >
                        {t("Cancel")}
                      </CircleBtn>
                    </div>
                  </>
                ) : null}
              </PaceTimer>
            </SettingsWrapper>
            <HoleWrapper>
              {courseList && courseList.length !== 0 ? (
                <>
                  {courseList?.map((c, index) => {
                    return (
                      <HoleBox key={c?.number}>
                        <div className="header">{getCourseName(c?.number)}</div>
                        <div className="box">
                          <div className="row">
                            {c?.frontHoles && c?.frontHoles.length !== 0 ? (
                              c?.frontHoles?.map((h, holeIndex) => {
                                return (
                                  <div className="hole-div" key={holeIndex}>
                                    <span>{h?.number}</span>
                                    <input
                                      type="number"
                                      id={h?.number}
                                      min={1}
                                      max={99}
                                      value={h?.pace}
                                      onChange={(e) =>
                                        handleFrontCourseList(
                                          e,
                                          index,
                                          holeIndex
                                        )
                                      }
                                    />
                                  </div>
                                );
                              })
                            ) : null}

                            {c?.frontHoles && c?.frontHoles.length !== 0 ? (
                              <>
                                <div className="total-time">
                                  <p>{t("Front")}</p>
                                  <p>{frontTotal(c)}</p>
                                </div>
                              </>
                            ) : null}
                          </div>
                          <div className="row">
                            {c?.backHoles && c?.backHoles.length !== 0 ? (
                              c?.backHoles?.map((h, holeIndex) => {
                                return (
                                  <div className="hole-div" key={holeIndex}>
                                    <span>{h?.number}</span>
                                    <input
                                      type="number"
                                      id={h?.number}
                                      min={1}
                                      max={99}
                                      value={h?.pace}
                                      onChange={(e) =>
                                        handleBackHolesCourseList(
                                          e,
                                          index,
                                          holeIndex
                                        )
                                      }
                                    />
                                  </div>
                                );
                              })
                            ) : null}
                            {c?.backHoles && c?.backHoles.length !== 0 ? (
                              <>
                                <div className="total-time">
                                  <p>{t("Back")}</p>
                                  <p>{backTotal(c)}</p>
                                </div>
                              </>
                            ) : null}
                          </div>
                          <div className="last-row">
                            <p>{t("Total")}</p>
                            <p>{courseTotal(c)}</p>
                          </div>
                        </div>
                      </HoleBox>
                    );
                  })}
                </>
              ) : (
                <>{t("No_data")}</>
              )}
            </HoleWrapper>
          </SettingContainer>
          <Modal
            open={alertMsg.get()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <PopUpContainer>
                <h2>{t("Confirm")}</h2>
                <p>{t("Discard_changes_to_Pace_settings")}?</p>
                <div className="action-btn">
                  <button className="primary" onClick={handleResetChanges}>
                    {t("Yes")}
                  </button>
                  <button
                    onClick={() => {
                      alertMsg.set(false);
                      setConfirmMsg(false);
                    }}
                  >
                    {t("No")}
                  </button>
                </div>
              </PopUpContainer>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
};

export default Settings;
